export default {
    routerName: '字典详情',
    dict: {
        category: '类别',
        label: '标题',
        sortOrder: '排序',
        data1: '数据1',
        data2: '数据2',
        data3: '数据3',
        data4: '数据4',
        data5: '数据5',
        data6: '数据6',
        data7: '数据7',
        data8: '数据8',
        data9: '数据9',
        data10: '数据10',
        status: '状态',
        open: '启用',
        close: '停用',
        createBy: '创建者',
        createTime: '创建时间',
        updateBy: '更新者',
        updateTime: '更新时间',
        body: '内容',
        hasBody: '有',
        hasNotBody: '无',
    },
};
